module.exports = __webpack_public_path__ + "img/install_icon3.14835650.svg";